import request from '@/utils/request';

export function getFinishTypeCascader(domainID, productGroupID) {
  return request({
    method: 'get',
    params: { domainID, productGroupID },
    url: 'finishtype/getFinishTypeCascader'
  });
}

export function getFinishesForDomainAndProductGroup(domainID, productGroupID) {
  return request({
    method: 'get',
    params: { domainID, productGroupID },
    url: 'finishtype/getFinishesForDomainAndProductGroup'
  });
}

export const storeExtensions = {
  actions: {
    getFinishTypeCascader({ dispatch }, { domainID, productGroupID }) {
      return new Promise((resolve, reject) =>
        getFinishTypeCascader(domainID, productGroupID)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    getFinishesForDomainAndProductGroup({ dispatch }, { domainID, productGroupID }) {
      return new Promise((resolve, reject) =>
        getFinishesForDomainAndProductGroup(domainID, productGroupID)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    }
  }
};
